import type { ServiceInformationProps } from '@/modules/Service/types'
import dayjs from 'dayjs'
import type {
    OtherStandardPaymentRange,
    OtherStandardSchedule,
} from '../Information/other-standard-config'

export const OTHER_STANDARD_METADATA_KEY = 'other_standard_payment_schedule'

export const emptyRange = (): OtherStandardPaymentRange => ({
    start_date: '',
    end_date: '',
    price: 0,
})

export const getOtherStandardSchedule = (metadata?: Record<string, any>) => {
    if (!metadata) return undefined

    return (metadata[OTHER_STANDARD_METADATA_KEY] ||
        metadata.payment_schedule ||
        metadata.other_standard) as OtherStandardSchedule | undefined
}

export const getFallbackRanges = (
    service: ServiceInformationProps['service']
): OtherStandardPaymentRange[] =>
    [
        {
            start_date:
                service.current_startdate ||
                service.first_startdate ||
                service.service_start_date?.toString(),
            end_date: service.current_enddate || service.first_enddate,
            price: service.service_price_register,
        },
    ].filter((range) => range.start_date || range.end_date)

export const dateValue = (value?: string) => (value ? value.slice(0, 10) : '')

export const formatPriceInput = (value?: number) =>
    Number(value || 0).toLocaleString('en-US')

export const parsePriceInput = (value: string) =>
    Number(value.replace(/[^\d]/g, '') || 0)

export const nextRangeFrom = (
    range?: OtherStandardPaymentRange
): OtherStandardPaymentRange => {
    const start = range?.end_date
        ? dayjs(dateValue(range.end_date)).add(1, 'day')
        : dayjs()

    return {
        start_date: start.format('YYYY-MM-DD'),
        end_date: start.endOf('month').format('YYYY-MM-DD'),
        price: range?.price || 0,
    }
}

export const normalizeSchedule = (schedule: OtherStandardSchedule) =>
    JSON.stringify({
        payment_method: schedule.payment_method || 'prepaid',
        payment_mode: schedule.payment_mode || 'one_time',
        description: schedule.description || '',
        ranges: (schedule.ranges || []).map((range) => ({
            start_date: dateValue(range.start_date),
            end_date: dateValue(range.end_date),
            price: Number(range.price || 0),
        })),
    })
